/* global pep_queue_config */

const main_element = document.querySelector('main');
let interval;
let last_known_position = pep_queue_config['position'];
let last_known_length = pep_queue_config['length'];
let failed_updates = 0;

function isVisible(start, end) {
    const now = new Date();

    /**
    start null           -> show
          in the past    -> show
          in the future  -> hide
    end   null           -> show
          in the past    -> hide
          in the future  -> show
    you need both start and end to agree to show

    tested in tests/js/unit/queueMsgDates.test.ts
    */

    return (
        (start === null || now > new Date(start)) &&
        (end === null || now < new Date(end))
    );
}

/**
 * Render incoming messages. Simply wipes the parent node and rerenders them all.
 */
function renderMessages(data) {
    const messages_root = document.getElementById('messages');
    messages_root.innerHTML = '';

    data.forEach((message) => {
        if (!isVisible(message.start, message.end)) {
            return;
        }

        const lang = document.documentElement.lang;
        const default_lang = Object.keys(message.title)[0];

        // localized objects of content
        const titles = message.title;
        const descs = message.description;
        const dates = message.formatted_start;

        const template = document.getElementById('message-template').content.cloneNode(true);
        template.querySelector('h2').innerHTML = titles[lang] ?? titles[default_lang];

        const date = dates === null ? null : dates[lang] ?? dates[default_lang];
        if (date) {
            template.querySelector('p.small').innerHTML = date;
        } else {
            template.querySelector('p.small').remove();
        }

        template.querySelector('div').innerHTML = descs[lang] ?? descs[default_lang];
        messages_root.appendChild(template);
    });
}

function renderPosition(you, total) {
    const el = document.getElementById('queue-position');
    if (!el) {
        return;
    }
    el.innerHTML = pep_queue_config['label_position'].replace('[!position!]', you).replace('[!total!]', total);
}

function renderTimer(seconds, hellip) {
    const timer_element = document.querySelector('.timeout');
    const hellip_element = document.querySelector('.hellip');

    if (timer_element) {
        let s = seconds;
        const m = Math.floor(s / 60); //Get remaining minutes

        s -= m * 60;
        if (seconds < 1) {
            timer_element.innerHTML = pep_queue_config['label_seconds'].replace('[!seconds!]', '&hellip;');
        } else {
            if (m <= 0) {
                timer_element.innerHTML = pep_queue_config['label_seconds'].replace('[!seconds!]', s);
            } else {
                timer_element.innerHTML = pep_queue_config['label_minutes'].replace('[!minutes!]', m).replace('[!seconds!]', s);
            }
        }
    }

    if (hellip_element) {
        hellip_element.innerHTML = hellip;
    }
}

function renderUpdate() {
    const now = new Date();
    const update_element = document.querySelector('.update');

    if (update_element) {
        update_element.innerHTML = pep_queue_config['label_update'].replace(
            '[!time!]', now.toLocaleTimeString([], {timeStyle: 'short'})
        );
    }
}

function jitter(base, range) {
    return base + Math.floor(Math.random() * range);
}

function getTimer(new_position) {
    // 4 min is our max because you risk losing your session and position
    // if you don't check before the stale timeout

    if (new_position > 500) {
        return jitter(180, 60); // 3m-4m
    }
    if (new_position > 200) {
        return jitter(120, 60); // 2m-3m
    }
    if (new_position > 100) {
        return jitter(60, 60); // 1m-2m
    }
    if (new_position > 50) {
        return jitter(30, 30); // 30s-1m
    }

    return jitter(15, 15); // 15s-30s
}

/**
 * Fetch new position, queue length.
 *
 * If that fails, use the last known position and start a new countdown.
 */
async function update() {
    try {
        clearTimeout(interval);
        let maintenace_mode = false;

        const response = await fetch(pep_queue_config['endpoint']);
        if (response.ok) {
            const data = await response.json();

            if (data.position < 1) {
                window.location.reload();
                return;
            }

            maintenace_mode = data.is_maintenance_mode;
            if (maintenace_mode) {
                main_element.classList.add('hidden');
            } else {
                main_element.classList.remove('hidden');
            }

            renderUpdate();
            last_known_position = data.position;
            last_known_length = data.length;
        } else {
            failed_updates++;
            // eslint-disable-next-line no-console
            console.error(response.status);

            if (failed_updates > 3) {
                window.location.reload();
            }
        }

        renderPosition(last_known_position, last_known_length);

        // In maintenance mode (queue = 0), put everyone on the same interval based on the length of the queue.
        // Considerations:
        // - in reality, when that interval hits will be randomly spread because everyone joined the queue at a different time
        // - although people who are early might be on a short interval, each interval it will eventually increase to match everyone else
        // eslint-disable-next-line no-use-before-define
        startCountdown(maintenace_mode ? getTimer(last_known_length) : getTimer(last_known_position));

    } catch (e) {
        failed_updates++;
        // eslint-disable-next-line no-console
        console.error(e);

        if (failed_updates > 3) {
            window.location.reload();
        }
    }
}
/**
 * Fetch new messages.
 */
setInterval(() => {
    fetch(pep_queue_config['messages'], {
        method: 'GET',
        headers: new Headers().append('cache-control', 'no-cache')
    }).then((response) => {
        if (!response.ok) {
            throw new Error('Failed fetching queue messages.');
        }
        return response.json();
    }).then((data) => {
        renderMessages(data);
    });
}, jitter(60, 30) * 1000);

function startCountdown(secs) {
    let hellip = '';

    interval = setInterval(() => {
        if (secs < 1) {
            update();
        }
        renderTimer(secs, hellip);
        secs--;

        hellip = hellip + '.';
        if (hellip.length === 4) {
            hellip = '';
        }

    }, 1000);
}

renderUpdate();
startCountdown(getTimer(last_known_position));
